var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-black mb-0"
        }, [_c('strong', [_vm._v("List Fleet Assigned")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.handleSubmit.apply(null, arguments);
            }
          }
        }, [_c('b-alert', {
          staticClass: "d-flex align-items-center",
          attrs: {
            "show": "",
            "variant": "primary"
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle mr-2"
        }), _c('strong', [_vm._v("Information")]), _vm._v(" : Unchecklist the fleet below if you want to unassign the job library to the fleet. ")]), _vm.groupedNotMatchEngines.length > 0 ? _c('div', {
          staticClass: "mb-4"
        }, _vm._l(_vm.groupedNotMatchEngines, function (engine) {
          return _c('b-alert', {
            key: engine.engine_id,
            staticClass: "mb-2 flex align-items-center text-black",
            attrs: {
              "show": "",
              "variant": "danger"
            }
          }, [_c('i', {
            staticClass: "fas fa-exclamation-triangle mr-2 text-danger"
          }), _c('div', {
            staticClass: "text-wrap text-black",
            staticStyle: {
              "line-height": "1.4"
            }
          }, [_c('strong', {
            staticClass: "mr-1"
          }, [_vm._v(" Warning: Data " + _vm._s(engine.engine_name) + " Fleet " + _vm._s(engine.vehicle_names.join(', ')) + ", ")]), _vm._v(" cannot be processed because the machine brand is not registered in the job library. ")])]);
        }), 1) : _vm._e(), _c('div', {
          staticClass: "mb-5 d-flex flex-wrap"
        }, _vm._l(_vm.activeSelectedFleets, function (fleet, i) {
          return _c('div', {
            key: i,
            staticClass: "d-flex",
            staticStyle: {
              "width": "220px"
            }
          }, [_c('div', {
            staticClass: "text-center"
          }, [_c('label', [_c('img', {
            staticClass: "img-fluid",
            staticStyle: {
              "width": "200px",
              "height": "auto"
            },
            attrs: {
              "src": require('@src/assets/images/fleet/PusherBarge.png'),
              "alt": "#"
            }
          })]), _c('div', {
            staticClass: "d-flex align-items-center justify-content-center"
          }, [_c('b-form-checkbox', {
            attrs: {
              "value": fleet.vehicle_id
            },
            model: {
              value: _vm.fleetIdsChecked,
              callback: function callback($$v) {
                _vm.fleetIdsChecked = $$v;
              },
              expression: "fleetIdsChecked"
            }
          }), _c('strong', [_vm._v(_vm._s(fleet.vehicle_name))])], 1)])]);
        }), 0), _c('div', {
          staticClass: "d-flex justify-content-between align-items-center mb-3"
        }, [_c('div', [_c('b-button', {
          attrs: {
            "variant": "danger",
            "disabled": !_vm.hasCheckedItems
          },
          on: {
            "click": _vm.handleBulkDelete
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-alt mr-2"
        }), _vm._v(" Bulk Delete ")])], 1)]), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-bordered table-hover"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticClass: "sticky-col sticky-col-1"
        }, [_c('b-form-checkbox', {
          staticClass: "d-flex justify-content-center",
          attrs: {
            "checked": _vm.isCheckedAll
          },
          on: {
            "change": _vm.toggleSelectAll
          }
        })], 1), _c('th', {
          staticClass: "text-nowrap sticky-col sticky-col-2"
        }, [_vm._v(" Fleet Name ")]), _c('th', {
          staticClass: "text-nowrap sticky-col sticky-col-3",
          staticStyle: {
            "min-width": "240px"
          }
        }, [_vm._v(" Equipment Name ")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "160px"
          }
        }, [_vm._v("Interval")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Last Maintenance (Date) "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Last Maintenance (RH) "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v(" Last Attachment ")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Equipment Category")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Job Type")]), _c('th', [_vm._v("Method")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Engine Position")])])]), _c('tbody', [_vm.paginatedForms.length === 0 ? _c('tr', [_c('td', {
          staticClass: "sticky-col sticky-col-1 text-muted py-4",
          attrs: {
            "colspan": 11
          }
        }, [_vm._v(" No data available. Please select at least one fleet and adjust filters if needed. ")])]) : _vm._l(_vm.paginatedForms, function (job, index) {
          var _job$job_libraries$ma, _job$job_libraries$ma2, _job$job_libraries$ma3, _job$job_libraries;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "sticky-col sticky-col-1"
          }, [_c('b-form-checkbox', {
            staticClass: "d-flex justify-content-center",
            attrs: {
              "type": "checkbox",
              "value": job.unique_id
            },
            model: {
              value: _vm.checkedJobs,
              callback: function callback($$v) {
                _vm.checkedJobs = $$v;
              },
              expression: "checkedJobs"
            }
          })], 1), _c('td', {
            staticClass: "sticky-col sticky-col-2"
          }, [_c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(" " + _vm._s(job.vehicle_name) + " ")])], 1), _c('td', {
            staticClass: "sticky-col sticky-col-3"
          }, [_vm._v(" " + _vm._s(((_job$job_libraries$ma = job.job_libraries.maintenance_master) === null || _job$job_libraries$ma === void 0 ? void 0 : _job$job_libraries$ma.equipment_name) || 'N/A') + " "), _c('br'), job.job_libraries.method === 'COUNTER' ? _c('small', [_vm._v(" " + _vm._s(job.job_libraries.power_series_name) + " ")]) : _vm._e()]), _c('td', [job.job_libraries.method == 'CALENDAR' ? _c('InputCurrency', {
            staticClass: "text-sm",
            attrs: {
              "prepend": "",
              "append": _vm.formatCalendarType(job.job_libraries.calendar_type),
              "required": ""
            },
            model: {
              value: job.job_libraries.calendar_interval,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "calendar_interval", $$v);
              },
              expression: "job.job_libraries.calendar_interval"
            }
          }) : _c('InputCurrency', {
            staticClass: "text-sm",
            attrs: {
              "prepend": "",
              "append": 'Hours',
              "required": ""
            },
            model: {
              value: job.job_libraries.interval_hour,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "interval_hour", $$v);
              },
              expression: "job.job_libraries.interval_hour"
            }
          })], 1), _c('td', [_c('date-picker', {
            staticStyle: {
              "width": "200px"
            },
            attrs: {
              "type": "date",
              "value-type": "YYYY-MM-DD",
              "format": "YYYY-MM-DD",
              "disabled-date": _vm.disableFutureDates,
              "input-attr": {
                required: true
              }
            },
            on: {
              "input": function input($event) {
                return _vm.handleDateChange(job.job_libraries, $event);
              }
            },
            model: {
              value: job.job_libraries.last_maintenance_date,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "last_maintenance_date", $$v);
              },
              expression: "job.job_libraries.last_maintenance_date"
            }
          })], 1), _c('td', [job.job_libraries.method === 'COUNTER' ? [_c('InputCurrency', {
            staticClass: "text-sm",
            attrs: {
              "prepend": "",
              "append": 'Hours',
              "required": ""
            },
            model: {
              value: job.job_libraries.last_maintenance_interval_hour,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "last_maintenance_interval_hour", $$v);
              },
              expression: "\n                          job.job_libraries.last_maintenance_interval_hour\n                        "
            }
          })] : [_vm._v("-")]], 2), _c('td', {
            staticStyle: {
              "min-width": "400px"
            }
          }, [_c('b-form-file', {
            attrs: {
              "multiple": ""
            },
            model: {
              value: job.job_libraries.attachment,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "attachment", $$v);
              },
              expression: "job.job_libraries.attachment"
            }
          })], 1), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(((_job$job_libraries$ma2 = job.job_libraries.maintenance_master) === null || _job$job_libraries$ma2 === void 0 ? void 0 : _job$job_libraries$ma2.equipment_name) || 'N/A') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(((_job$job_libraries$ma3 = job.job_libraries.maintenance_job_type) === null || _job$job_libraries$ma3 === void 0 ? void 0 : _job$job_libraries$ma3.job_type_index) || 'N/A') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(job.job_libraries.method || 'Calendar') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(((_job$job_libraries = job.job_libraries) === null || _job$job_libraries === void 0 ? void 0 : _job$job_libraries.power_type_name) || '-') + " ")])]);
        })], 2)])]), _c('div', {
          staticClass: "my-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black fw-bold"
        }, [_vm._v(_vm._s(_vm.totalRows))])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.jobList.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.onPageChange
          },
          model: {
            value: _vm.jobList.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.jobList.params, "page", $$v);
            },
            expression: "jobList.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "change": _vm.onLimitChange
          },
          model: {
            value: _vm.jobList.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.jobList.params, "limit", $$v);
            },
            expression: "jobList.params.limit"
          }
        })], 1)]), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "w-50 mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('close');
            }
          }
        }, [_vm._v(" Cancel ")]), _c('b-button', {
          staticClass: "w-50",
          attrs: {
            "variant": "primary",
            "type": "submit"
          }
        }, [_vm._v(" Save ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }